import app from 'firebase/app';
import 'firebase/auth';
import jwt_decode from 'jwt-decode';
import { UserSignUp } from '@app/types';
import { client } from '@app/providers';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATATABE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
};

app.initializeApp(config);

export async function createUser({
  firstName,
  lastName,
  email,
  password,
  phone,
  company,
}: UserSignUp) {
  await app.auth().createUserWithEmailAndPassword(email, password);
  const { currentUser } = app.auth();

  if (currentUser) {
    await currentUser.updateProfile({
      displayName: firstName + ' ' + lastName,
    });
  }

  return currentUser;
}

export async function signIn(email: string, password: string) {
  await app.auth().signInWithEmailAndPassword(email, password);
  const { currentUser } = app.auth();
  return currentUser;
}

export async function signInWithGoogle() {
  var provider = new app.auth.GoogleAuthProvider();
  await app.auth().signInWithPopup(provider);
  const { currentUser } = app.auth();
  return currentUser;
}

export async function ResetPassword(emailAddress: string) {
  return await app
    .auth()
    .sendPasswordResetEmail(emailAddress)
    .then(function() {
      return { success: true };
    })
    .catch(function(error) {
      return { error: error, success: false };
    });
}

export function signOut() {
  deleteToken();
  localStorage.clear();
  client.cache.reset();
  app.auth().signOut();
}

export async function getToken(currentUser: app.User | null) {
  if (currentUser) {
    return await currentUser
      .getIdToken(true)
      .then(async function(idToken: string) {
        var decodedToken: any = await jwt_decode(idToken);
        localStorage.setItem('token', idToken);
        return { token: idToken, expiryDateTime: decodedToken.exp };
      })
      .catch(function(error: any) {
        return {};
      });
  } else {
    return {};
  }
}

function deleteToken() {
  localStorage.removeItem('token');
}

export async function checkToken(token: string) {
  var decodedToken: any = await jwt_decode(token);
  var dateNow = new Date();
  if (decodedToken && decodedToken.exp < dateNow.getTime() / 1000) {
    signOut();
  }
}

export async function changePassword(oldPassword: string, newPassword: string) {
  var user: any = app.auth().currentUser;
  if (user) {
    let credential = app.auth.EmailAuthProvider.credential(
      user.email,
      oldPassword,
    );
    return await user
      .reauthenticateWithCredential(credential)
      .then(async (res: any) => {
        return await user
          .updatePassword(newPassword)
          .then(function() {
            return { user: user, success: true };
          })
          .catch(function(error: any) {});
      })
      .catch(function(error: any) {
        return error;
      });
  }
}

export async function createPassword(
  email: string,
  oldPassword: string,
  newPassword: string,
) {
  const user: any = await signIn(email, oldPassword);
  if (user) {
    let credential = app.auth.EmailAuthProvider.credential(
      user.email,
      oldPassword,
    );
    return await user
      .reauthenticateWithCredential(credential)
      .then(async (res: any) => {
        return await user
          .updatePassword(newPassword)
          .then(function() {
            return { user: user, success: true };
          })
          .catch(function(error: any) {});
      })
      .catch(function(error: any) {
        return error;
      });
  }
}

export default app;
